import { render, staticRenderFns } from "./AdminDashboardView.vue?vue&type=template&id=779f1c7c&scoped=true"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboardView.vue?vue&type=style&index=0&id=779f1c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779f1c7c",
  null
  
)

export default component.exports